import { LanguageKey } from '../../domain';

export function helpdeskArticle(language: LanguageKey, id: string): string {
  return `https://help.lessonup.com/${language}/articles/${id}`;
}
